<form [formGroup]="alertForm" (ngSubmit)="onSubmit()" #alertFormRef="ngForm">
	<div class="modal-body">
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-2 label-control">Nombre</label>
				<div class="col-9">
					<input disabled type="text" name="nombre" id="nombre" formControlName="nombre" class="form-control" />
				</div>
			</div>
		</div>
		<!-- <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Umbral Dias</label>
                <div class="col-9">
                    <input type="number" name="umbralDias" id="umbralDias" formControlName="umbralDias" class="form-control" >
                    <div *ngIf="alertFormRef.submitted &&( alertForm.get('umbralDias').invalid ||  alertForm.get('umbralDias').dirty)" class="invalid-feedback">
                        <div *ngIf="alertForm.get('umbralDias').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div> -->
		<div class="form-group position-relative mx-auto" *ngIf="showCount">
			<div class="row">
				<label for="" class="col-2 label-control">Umbral Cantidad</label>
				<div class="col-9">
					<input type="number" name="umbralCantidad" id="umbralCantidad" formControlName="umbralCantidad" class="form-control" />
					<div *ngIf="alertFormRef.submitted && (alertForm.get('umbralCantidad').invalid || alertForm.get('umbralCantidad').dirty)" class="invalid-feedback">
						<div *ngIf="alertForm.get('umbralCantidad').errors?.required">Campo requerido</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
			<i class="la la-paper-plane-o d-lg-none"></i>
			<span class="d-none d-lg-block">Guardar</span>
		</button>
		<button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
			<span class="d-none d-lg-block">Cerrar</span>
		</button>
	</div>
</form>
